import { NavBarBtnModel } from 'common/src/models';
import { ProductTypes } from 'common/src/modules/products/product-types';
import { SubscriptionListTabsEnum } from '../../enums';
import {
  ControlTypeEnum,
  InputDropdownTypeEnum,
  PositionInfoListModel,
  PositionItemTypeEnum
} from 'common/src/modules/position-card/position-card-models.model';
import { PURPOSES_LIST } from '../../../trade/trade.constants';
import { PositionGroupingEnum, PriceOptionEnum } from '../../../shared/enums';
import { PositionGroupModel } from '../../../shared/models';

export function getPositionsButtons(positionGroupingOption: PositionGroupingEnum, positionsGroups?: PositionGroupModel[]): NavBarBtnModel[] {
  positionsGroups = positionsGroups.filter(g => !g.system || g.isDefault);
  const buttons: NavBarBtnModel[] = [
    {
      classes: 'btn-white',
      text: 'POSITIONS_GROUPING.MOVE_TO_GROUP',
      multipleText: 'POSITIONS_GROUPING.MOVE_TO_GROUP',
      badgeClass: 'rnpl-badge--grey',
      iconName: 'shuffle',
      actionName: 'onBulkMoveToGroup',
      backdropClass: 'mb-48',
      showCondition: positionGroupingOption === PositionGroupingEnum.USER_DEFINED
        && positionsGroups.length > 1,
      actions: [
        {
          actionName: 'onBulkMoveToGroup',
          actionTitle: 'POSITIONS_GROUPING.MOVE_TO_GROUP',
          actionIcon: 'shuffle'
        },
        {
          actionName: 'onBulkCreateGroup',
          actionTitle: 'POSITIONS_GROUPING.CREATE_GROUP',
          actionIcon: 'plus'
        },
      ]
    },
    {
      classes: 'btn-white',
      text: 'POSITIONS_GROUPING.CREATE_GROUP',
      multipleText: 'POSITIONS_GROUPING.CREATE_GROUP',
      badgeClass: 'rnpl-badge--grey',
      iconName: 'plus',
      actionName: 'onBulkCreateGroup',
      backdropClass: 'mb-48',
      showCondition: positionGroupingOption === PositionGroupingEnum.USER_DEFINED
        && positionsGroups.length === 1,
    },
    {
      classes: 'btn-white red',
      text: 'BUTTON.REMOVE',
      multipleText: 'BUTTON.REMOVE',
      badgeClass: 'rnpl-badge--red',
      iconName: 'minus-circle',
      actionName: 'onDeletePositionsClick',
    }
  ];

  return buttons.filter(b => !b.hasOwnProperty('showCondition') || b.showCondition);
}

export function generatePositionsCardsInfo(
  productType: ProductTypes,
  documentStatus: SubscriptionListTabsEnum,
  priceOption: PriceOptionEnum,
  smallBusiness: boolean
): PositionInfoListModel[] {

  let positionInfoList: PositionInfoListModel[] = [
    {
      label: 'FORM.DESCRIPTION',
      prop: 'providedServices',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXT_EDITOR,
      hideWithProductType: [ProductTypes.DIGITAL],
    },
    {
      label: 'FORM.DESCRIPTION',
      prop: 'productDescription',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.TEXT_EDITOR,
      hideWithProductType: [ProductTypes.SERVICES],
    },
    {
      label: 'COLUMN.QUANTITY',
      prop: 'quantity',
      unitType: 'unitType',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.NUMBER,
    },
    {
      label: 'COLUMN.UNIT_PRICE_NET',
      prop: 'netUnitPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showUnitOnly: true,
      showCondition: (priceOption === PriceOptionEnum.NET) || smallBusiness
    },
    {
      label: 'COLUMN.UNIT_PRICE_GROSS',
      prop: 'grossUnitPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showUnitOnly: true,
      showCondition: (priceOption === PriceOptionEnum.GROSS) && !smallBusiness
    },
    {
      label: 'COLUMN.AMOUNT_NET',
      prop: 'netTotalPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showUnitOnly: true,
      showCondition: (priceOption === PriceOptionEnum.NET) || smallBusiness
    },
    {
      label: 'COLUMN.AMOUNT_GROSS',
      prop: 'grossTotalPrice',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.INPUT_DROPDOWN,
      listItems: PURPOSES_LIST,
      inputDropdownType: InputDropdownTypeEnum.CURRENCY,
      showUnitOnly: true,
      showCondition: (priceOption === PriceOptionEnum.GROSS) && !smallBusiness
    },
    {
      label: 'COLUMN.MARGIN',
      prop: 'marginData',
      suffix: '€',
      type: PositionItemTypeEnum.WITH_CONTROL,
      controlType: ControlTypeEnum.PROFIT,
      currencyConversion: true,
      hideWithProductType: [ProductTypes.GOODS, ProductTypes.DIGITAL],
      showWithDocumentStatus: [
        SubscriptionListTabsEnum.DRAFT,
        SubscriptionListTabsEnum.OPEN,
      ],
    },
  ];

  positionInfoList = positionInfoList
    .filter((item) => {
      if (item.hideWithProductType) {
        return !item.hideWithProductType.includes(productType);
      }
      return true;
    })
    .filter((item) => {
      if (item.showWithDocumentStatus) {
        return item.showWithDocumentStatus.includes(documentStatus);
      }
      return true;
    })
    .filter((item) => !item.hasOwnProperty('showCondition') || item.showCondition);

  return positionInfoList;

}
